import { server } from 'config/environment'
import { makeAutoObservable } from 'mobx'

function supported() {
  const bridge = window['__DRESSCODE_WEBVIEW_BRIDGE'] ?? {}
  const supported = bridge?.getSupportedMessages?.() ?? []
  return supported
}

function detect(): boolean {
  if (server) return false

  if (supported().includes('__REQUEST_HIDE_CLOSE_BUTTON')) {
    window.ReactNativeWebView?.postMessage('__REQUEST_HIDE_CLOSE_BUTTON')
    return true
  }

  const params = new URLSearchParams(location.search)
  return params.has('webview')

}

class WebviewController {
  detected = detect()

  constructor() {
    makeAutoObservable(this)
  }

  close() {
    if (supported().includes('__REQUEST_CLOSE_WEBVIEW')) {
      window.ReactNativeWebView?.postMessage('__REQUEST_CLOSE_WEBVIEW')
    }
  }
}

export const webview = new WebviewController()
